import { useFormContext } from 'react-hook-form';
import { usePercentageValidation } from './usePercentageValidation';
import type { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';

export const useUboPercentageUpdate = () => {
  const formMethods = useFormContext<OwnersCenterFormType>();
  const { validatePercentageChange, validateTotalPercentage } =
    usePercentageValidation(formMethods);

  const handleUboPercentageChange = async ({
    fieldName,
  }: {
    fieldName: keyof OwnersCenterFormType;
  }) => {
    await validatePercentageChange(fieldName);
  };

  return { handleUboPercentageChange, validateTotalPercentage };
};
